let config = {a:10, b:20};
const {a} = config;
const init = [1,2,3,4]
const final = [...init, 5];